<template>
  <DefaultModal>
    <template #header>
      <div class="header">
        <img
            src="@/assets/images/svg/close.svg"
            alt="exchange icon"
            class="header__close"
            @click="$emit('close')"
        />
      </div>
    </template>

    <template #content>
      <div ref="privacyAndTerms">
        <h1>Privacy Policy</h1>
        <div class="justify" v-html="privacy"></div>
        <h1>Terms of Service</h1>
        <div class="justify" v-html="terms"></div>
      </div>
    </template>

    <template #footer>
      <img class="arrow-up" src="@/assets/images/svg/arrow-up.svg" @click="goUpHandler" />
    </template>
  </DefaultModal>
</template>

<script>
import { privacy, terms } from "@/constants/template";
import DefaultModal from "@/components/ui/shared/modals/DefaultModal";

export default {
  name: "TermsAndPrivacy",
  components: { DefaultModal },
  data() {
    return {
      privacy,
      terms,
    };
  },
  methods: {
    goUpHandler() {
      this.$refs.privacyAndTerms.scrollIntoView()
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin: 1rem;

  &__close {
    cursor: pointer;
  }
}

.justify {
  text-align: justify;
}

.arrow-up {
  position: fixed;
  right: calc(50% - 430px);
  bottom: calc(10% + 1rem);
  cursor: pointer;
}
</style>